<template>
    <div class="news-box">
        <!-- 新闻列表 -->
        <div class="news" v-if="newDetail == false">
            <p class="place">您所在的位置：<span class="place-text">机构简介</span></p>
            <!-- <p>暂无新闻</p> -->
            <div class="news-list">
                <div class="news-item" v-for="(item, index) in newsList" :key="index" @click="toDetail(item)">
                    <div class="news-date">
                        <div class="date">{{ item.date }}</div>
                        <div class="year">{{ item.year }}</div>
                    </div>
                    <div class="news-text">{{ item.title }}</div>
                </div>
            </div>

            <div class="page-box">
                <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    layout="prev, pager, next"
                    :page-size="pageSize"
                    :total="length">
                </el-pagination>
            </div>
        </div>
        <!-- 新闻详情 -->
        <div class="news" v-else>
            <p class="place">您所在的位置：<span @click="toList">新闻中心</span>><span class="place-text">正文</span></p>
            <p class="news-title">{{ article.title }}</p>
            <p class="news-info">
                <span class="news-info-item" v-show="article.author">作者：{{ article.author }}</span>
                <span class="news-info-item">发布时间：{{ article.createTime }}</span>
                <span class="news-info-item">访问次数：{{ article.viewNum }}</span>
            </p>
            <!-- <div v-html="article.content" class="article"></div> -->
            <div class="ql-snow">
                <div class="ql-editor article" v-html="article.content">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import '../../assets/css/common.css'
import '../../assets/css/quill.bubble.css'
import '../../assets/css/quill.core.css'
import '../../assets/css/quill.snow.css'
    export default {
        name: 'news',
        data() {
            return {
                newsList: [],
                length: 20,
                newDetail: false,
                pageNum: 1,
                pageSize: 10,
                article: {}
            }
        },
        created() {
            this.getNewsList()
        },
        methods: {
            getNewsList() {
                this.http.get('/newspaper/list?pageNum=' + this.pageNum + '&pageSize=' + this.pageSize).then(res => {
                    console.log(res.data.data.list)
                    this.length = res.data.data.total
                    this.newsList = res.data.data.list
                    this.newsList.forEach(item => {
                        item.date = item.createTime.slice(5, 10)
                        item.year = item.createTime.slice(0,4)
                    })
                    console.log(this.newsList)
                }) 
            },
            handleCurrentChange(val) {
                console.log(val)
                this.pageNum = val
                this.getNewsList()
            },
            toDetail(e) {
                console.log(e)
                this.http.get('/newspaper/get?id=' + e.id).then(res => {
                    console.log(res.data.data)
                    this.article = res.data.data
                    this.newDetail = true
                    
                }) 
               
            },
            toList() {
                this.newDetail = false
            }
        }
    }
</script>

<style lang="less" scoped>
    // @import '~@/assets/css/quill.core.css';
    // @import '~@/assets/css/quill.bubble.css';
    // @import '~@/assets/css/quill.snow.css';
    .news-box {
        background-color: #FAF9F9;
        width: 100%;
        // height: 100vh;
        .news {
            width: 1160px;
            margin: 0 auto;
            padding: 30px 0px;
            box-sizing: border-box;
            .place {
                font-size: 15px;
                font-weight: 500;
                color: #333333;
                line-height: 21px;
                cursor: pointer;
                .place-text {
                    color: #0091FF;  
                }
            }
            .news-list {
                .news-item {
                    width: 100%;
                    height: 143px;
                    padding: 30px 0;
                    box-sizing: border-box;
                    border-bottom: 1px dashed #979797;
                    display: flex;
                    cursor: pointer;
                    .news-date {
                        width: 80px;
                        height: 80px;
                        background: #FFFFFF;
                        border-radius: 4px;
                        padding: 8px 5px;
                        box-sizing: border-box;
                        text-align: center;
                        font-size: 23px;
                        font-weight: 500;
                        color: #333333;
                        .date {
                            border-bottom: 1px solid #ECEBEB;
                        }
                    }
                    .news-text {
                        width: 1065px;
                        margin-left: 15px;
                        line-height: 42px;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        font-size: 24px;
                    }
                }
            }

        }
        .page-box {
            width: 100%;
            text-align: center;
            margin-top: 80px;
            /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
                background-color: #0091FF;
                color: #FFF;
            }
            /deep/.el-pager li {
                width: 40px;
                height: 40px;
                background-color: #fff;
                border-radius: 0;
                line-height: 40px;
                text-align: center;               
                font-size: 16px;
                border: 1px solid #D8D8D8;
                margin: 0;
            }
            /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .btn-next{
                width: 40px;
                height: 40px;
                background-color: #fff;
                border-radius: 0;
                line-height: 40px;
                text-align: center;               
                font-size: 16px;
                border: 1px solid #D8D8D8;
                margin: 0;
            }
            /deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
                color: #0091FF;
            }
        }
        .news-title {
            font-size: 30px;
            font-weight: 600;
            color: #333333;
            line-height: 42px;
            text-align: center;
            margin-top: 30px;
        }
        .news-info {
            font-size: 16px;
            font-weight: 400;
            color: #656464;
            line-height: 28px;
            text-align: center;
            margin-top: 20px;
            .news-info-item {
                margin-right: 10px;
            }
        }
        .article {
            width: 100%;
            margin-top: 20px;
        }
        // .ql-align-center {
        //     text-align: center !important;
        // }

        // .ql-editor .ql-font-serif {
        //     font-family: Georgia,Times New Roman,serif;
        //     line-height: 42px !important;
        // }
    }
</style>